import * as React from 'react';
import { MyNotificationsContainerProps } from 'app/area/user-profile/my-notifications/types';
import { AddSmsConsent } from 'app/area/user-profile/my-notifications/consents/add-sms-consent';
import { AddPushConsent } from 'app/area/user-profile/my-notifications/consents/add-push-consent';
import { SimpleFormComponentProps } from 'app/infrastructure/simple-form/types';
import { configurationAccess } from 'app/area/user-profile/my-notifications/configuration-access';
import styles from './top-panel.scss';
import { FmcContext } from 'app/infrastructure/push/context';

interface TopPanelPropsExternal {
  recipientId: number;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  loadData: () => void;
}

export type TopPanelProps = MyNotificationsContainerProps & TopPanelPropsExternal;

export const TopPanel = (props: TopPanelProps) => {
  const { permission, formComponent: SimpleForm, loadData } = props;

  const hasPermissions = permission && Object.keys(permission).map(key => permission[key]).includes(true);

  return (hasPermissions ? <div className={`row ${styles.buttonContainer}`}>
    <div className="col-md-12">
      {permission && permission.sms && <AddSmsConsent
        {...props}
        formComponent={SimpleForm}
        loadConsents={loadData} />}

      {configurationAccess.push && permission && permission.push && <FmcContext.Consumer>
        {value => <AddPushConsent
          {...props}
          value={value}
          formComponent={SimpleForm}
          loadConsents={loadData} />
        }
      </FmcContext.Consumer>
      }
    </div>
  </div> : null);
};
